<template>
  <Loading v-if="loading"></Loading>
  <router-view v-else class="py-0"></router-view>
</template>

<script>
import { handleAccessToken } from "@/shared/helpers/helpers";
export default {
  data() {
    return {
      loading: true,
    };
  },
  created() {
    const paggloDelivery = localStorage.getItem("pagglo-delivery");
    if (paggloDelivery !== undefined) {
      this.$store.dispatch("objStoreStorage", JSON.parse(paggloDelivery));
    }
    const localCarrinho = localStorage.carrinho;
    if (localCarrinho !== undefined) {
      this.$store.dispatch("pedidoLocalStorage", JSON.parse(localCarrinho));
    }
    // if (!localStorage.getItem("accept-cookies")) {
    //   this.$swal({
    //     position: "bottom-end",
    //     backdrop: false,
    //     showClass: { popup: "style-cookies" },
    //     text: `Os nossos cookies estão ativados pra te oferecer uma experiência ${window.NOME} completa. Quando você está navegando no nosso site, aceita esta condição.`,
    //     confirmButtonText: "ACEITAR",
    //     preConfirm: () => {
    //       return localStorage.setItem("accept-cookies", new Date());
    //     },
    //   });
    // }
  },
  beforeMount() {
    let accessToken = this.$route.query.accessToken;
    const iu = this.$route.query.u;
    accessToken = accessToken ? accessToken : iu;
    if (accessToken) {
      handleAccessToken(accessToken).then(() => (this.loading = false));
    } else {
      this.loading = false;
    }
  },
};
</script>
